import React from 'react'

const PageCentralizedLayoutTitle = ({ children }) => (
  <h2 className='h1 mt0 mb3'>
    {children}
  </h2>
)

export default PageCentralizedLayoutTitle
